import { createContext, createSignal } from "solid-js";
import type { IPreparedHistoryItem } from "~/solidJs/widgets/HistoryWidget/helpers/prepareNewHistoryItems";

export const createHistoryStore = () => {
	const [getHistoryStore, setHistoryStore] = createSignal<IPreparedHistoryItem[]>([]);

	return { getHistoryStore, setHistoryStore };
};
export const HistoryContext = createContext<ReturnType<typeof createHistoryStore>>();
